import { render, staticRenderFns } from "./UsuarioToolbar.vue?vue&type=template&id=8a2d9f2a&scoped=true&"
import script from "./UsuarioToolbar.vue?vue&type=script&lang=js&"
export * from "./UsuarioToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2d9f2a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/shared-components/toolbar/UsuarioToolbar.vue
// module id = 945
// module chunks = 28